export enum BreadcrumbsActionType {
  setAlias = '[BreadcrumbsActionType] setBreadcrumbAlias',
  removeAlias = '[BreadcrumbsActionType] removeBreadcrumbAlias',
}

export function setBreadcrumbAlias(key: string, label: string) {
  return {
    type: BreadcrumbsActionType.setAlias,
    key,
    label,
  };
}

export function removeBreadcrumbAlias(key: string) {
  return {
    type: BreadcrumbsActionType.removeAlias,
    key,
  };
}
